import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _createReducer;

import { createReducer } from 'redux-act';
import { updatePassword, deactivateOtp, deactivateUser, createPassword, deleteTransaction, signout, updateProfileSuccess, sendSmsVerification, sendSmsReverification } from "../../actions";
export default createReducer((_createReducer = {}, _defineProperty(_createReducer, signout.success, function () {
  return 'You have been signed out.';
}), _defineProperty(_createReducer, updatePassword.success, function () {
  return 'Your password has been successfully updated.';
}), _defineProperty(_createReducer, deactivateOtp.success, function () {
  return "You've successfully opted-out of MFA.";
}), _defineProperty(_createReducer, deactivateUser.success, function () {
  return 'Your account has been successfully deleted.';
}), _defineProperty(_createReducer, createPassword.success, function () {
  return 'Your password has been successfully created.';
}), _defineProperty(_createReducer, updateProfileSuccess, function (state, payload, _ref) {
  var showMessages = _ref.showMessages,
      updating = _ref.updating;
  if (!showMessages) return;

  if (updating === 'name') {
    return 'Your name has been successfully updated.';
  }

  if (updating === 'subscriptions') {
    return 'Notification preferences updated.';
  }
}), _defineProperty(_createReducer, sendSmsVerification.success, function (state, payload, _ref2) {
  var showMessages = _ref2.showMessages;
  if (!showMessages) return;
  return "We've sent you a new verification code.";
}), _defineProperty(_createReducer, sendSmsReverification.success, function (state, payload, _ref3) {
  var showMessages = _ref3.showMessages;
  if (!showMessages) return;
  return "We've sent you a new verification code.";
}), _defineProperty(_createReducer, deleteTransaction.success, function () {
  return 'Transaction deleted.';
}), _createReducer), null);